export type ConstructionStageState = "not_started" | "in_progress" | "done";

export const STAGE_STATE_LABELS: Record<ConstructionStageState, string> = {
  not_started: "Nie rozpoczęty",
  in_progress: "W toku",
  done: "Zrobiony",
};

export interface ConstructionStageRow {
  id: string;
  key: string;
  label: string;
  state: ConstructionStageState;
  state_display: string;
  due_date: string | null;
  completed_at: string | null;
  note: string;
  order: number;
  is_custom: boolean;
  depends_on: string[];
  /** „Nasz ruch": nic już nie blokuje i etap nie jest zrobiony. Liczone z grafu na żywo. */
  is_ready: boolean;
  blocked_by: { id: string; label: string }[];
  /** Zrobiony mimo niezrobionych wymagań — dozwolone, ale musi być widać. */
  out_of_order: boolean;
}

export interface ConstructionBoard {
  stages: ConstructionStageRow[];
  summary: {
    total: number;
    done: number;
    in_progress: number;
    ready: number;
    out_of_order: number;
  };
}
